import styled from 'styled-components';
import Text from '../../BuildingBlocks/Text';
import { mixins, media, colors } from "../../css"

export const StyledCopyBody = styled(Text.CopyBody)`
  margin-top: ${mixins.pxToRem(12)};
  line-height: 1.4rem;

  a {
    color: ${colors.colorBlue};
  }

  ${media.greaterThan('lg')`
    margin-top: ${mixins.pxToRem(10)};
  `};
`;

export const StyledDescription = styled(Text.CopyBody)`
  a {
    color: ${colors.colorBlue};
  }
`;

export const StyledDefaultLabel = styled.div`
  margin-top: ${mixins.pxToRem(12)};
  a {
    color: ${colors.colorBlue};
  }
`;

export const StyledToolTipContainer = styled.span`
  height: ${mixins.pxToRem(22)};
  margin-left: ${mixins.pxToRem(8)};

  button {
    height: ${mixins.pxToRem(22)};
    display: inline-block;
    vertical-align: middle;
    margin-top: ${mixins.pxToRem(-2)};
  }
`;
